import { ApiClient } from '@webapp/core/services/ApiClient'
import { makeSystemPreferencesRepository } from './SystemPreferencesRepository'

export const SystemPreferencesRepository = makeSystemPreferencesRepository({
  httpClient: ApiClient,
})
